import { api } from "@/api";
import type { PolicyMetaData } from "@/core/types";

export async function getPolicyMetadata(): Promise<PolicyMetaData> {
  return api.publicTyped.get_policy_metadata();
}
